import React from "react";
import {Button, Typography} from "@mui/material";
import "./pendingPage.css";

const PendingPage = (props) => {
    const { onLogout } = props;

    return <div className="pendingPage">
        <Typography variant="h5" color="primary" paragraph={true}>
            Access Pending Activation
        </Typography>
        <Typography variant="body1" paragraph={true}>
            It looks like your account is currently missing its role configuration.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph={true}>
            This can occur during initial setup or system synchronization. Please contact support or your account administrator to activate your access.
        </Typography>
        <div className="action">
            <Button
                color="secondary"
                variant="outlined"
                onClick={onLogout}
            >
                Logout
            </Button>
        </div>
    </div>
};

export default PendingPage;
